import { PUBLIC_DIFFUSION_API_ENDPOINT } from '$env/static/public';
import {
	Client as DiffusionApiClient,
	type GeneratedMaterial,
	type MaterialPatch,
	type CreateMaterialRequest,
	type CreateMaterialResponse
} from '$lib/diffusionApi';

export class MaterialsClient {
	private diffusionApiClient: DiffusionApiClient;

	constructor(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public setToken(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public async createMaterial(image: string, customInstructions?: string): Promise<CreateMaterialResponse | undefined> {
		const requestBody: any = { image };
		if (customInstructions) {
			requestBody.custom_instructions = customInstructions;
		}
		const response = await this.diffusionApiClient.default.createMaterialMaterialPost(requestBody);
		return response;
	}

	public async getMaterials(
		user_id: string,
		config?: {
			skip?: number;
			limit?: number;
			most_recent_first?: boolean;
			generation_ids?: string[];
		}
	): Promise<GeneratedMaterial[]> {
		const response = await this.diffusionApiClient.default.getMaterialsMaterialsGet(
			user_id,
			config?.skip,
			config?.limit,
			config?.most_recent_first,
			config?.generation_ids
		);
		return response.materials;
	}

	public async patchMaterials(patches: MaterialPatch[]) {
		try {
			const response = await this.diffusionApiClient.default.patchMaterialsMaterialsPatch({
				patches
			});
			return response;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}

	public async saveMaterial(generation_id: string) {
		return this.patchMaterials([{ generation_id, saved: true }]);
	}

	public async unsaveMaterial(generation_id: string) {
		return this.patchMaterials([{ generation_id, saved: false }]);
	}

	public async deleteMaterial(generation_id: string) {
		return this.patchMaterials([{ generation_id, deleted: true }]);
	}

	public async markAsDownloaded(generation_id: string) {
		return this.patchMaterials([{ generation_id, downloaded: true }]);
	}
}